export default __webpack_public_path__ + "static/media/getstarted-ilmx.a4d9d6e1.png";